import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { usePrevious } from 'web-services/lib/hooks';
import NavButton from 'web-ui-kit/buttons/NavButton';
import { surfaceM } from 'web-ui-kit/colors';
import { MQ_FOR_TABLET_LANDSCAPE_UP, MQ_FOR_TABLET_LANDSCAPE_BELOW } from 'web-ui-kit/media';
import FormModal from 'web-ui-kit/modals/FormModal';
import { Header5LargeStyles, BodySmallStyles, BodyLargeStyles, Header3SmallStyles } from 'web-ui-kit/typography';
import AdditionalOptions from 'web-ui-kit/ProductDetails/components/AdditionalOptions';
import Addons from 'web-ui-kit/ProductDetails/components/Addons';
import Availability from 'web-ui-kit/ProductDetails/components/Availability';
import CTA from 'web-ui-kit/ProductDetails/components/CTA';
import CuratedComment from 'web-ui-kit/ProductDetails/components/CuratedComment';
import PhysicalDetailsAndOverview from 'web-ui-kit/ProductDetails/components/PhysicalDetailsAndOverview';
import PrimaryInfo from 'web-ui-kit/ProductDetails/components/PrimaryInfo';
import PrimaryInfoCustomProp from 'web-ui-kit/ProductDetails/components/PrimaryInfoCustomProp';
import CheckBadge from 'web-ui-kit/assets/CheckBadge';
import SectionBreak from 'web-ui-kit/ProductDetails/components/SectionBreak';
import SimilarProducts from 'web-ui-kit/ProductDetails/components/SimilarProducts';
import SkeletonLoader from 'web-ui-kit/ProductDetails/components/SkeletonLoader';
import StackedProductImageCarousel from 'web-ui-kit/ProductDetails/components/StackedProductImageCarousel';
import ThumbnailProductImageCarousel from 'web-ui-kit/ProductDetails/components/ThumbnailProductImageCarousel';
import TwoDOnly from 'web-ui-kit/ProductDetails/components/TwoDOnly';
import Variants from 'web-ui-kit/ProductDetails/components/Variants';
import VariantsWithAttributes from 'web-ui-kit/ProductDetails/components/VariantsWithAttributes';
import AddedToCartPopup from 'web-ui-kit/ProductDetails/components/AddedToCartPopup';
import NavOneColumn from 'web-ui-kit/ProductDetails/components/NavOneColumn';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function PromoExclusion() {
  var BadgeLine = styles.BadgeLine,
      Description = styles.Description,
      StyledCheckBadge = styles.StyledCheckBadge,
      Wrapper = styles.Wrapper;
  return (
    /*#__PURE__*/
    React.createElement(Wrapper, null,
    /*#__PURE__*/
    React.createElement(BadgeLine, null,
    /*#__PURE__*/
    React.createElement(StyledCheckBadge, {
      size: 16
    }), "Everyday deal"),
    /*#__PURE__*/
    React.createElement(Description, null, "No more searching for sales, you\u2019ll always get the best deal on Everyday Deal items. This item is excluded from promotions."))
  );
}

var styles = {
  BadgeLine: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n    display: flex;\n    align-items: center;\n    margin-bottom: 6px;\n  "])), Header5LargeStyles),
  Description: styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), BodySmallStyles),
  StyledCheckBadge: styled(CheckBadge)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-right: 4px;\n  "]))),
  Wrapper: styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin-bottom: 1.325rem;\n    padding: 0 1rem 1rem;\n\n    ", " {\n      margin-bottom: 0;\n      padding: 0 0 1rem 0;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP)
};

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5, _templateObject6, _templateObject7;
/**
 * The primary product details content.
 */


function ProductDetailsContent(_ref) {
  var _curatedRec$comment;

  var _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$freeShippingMess = _ref.freeShippingMessageEnabled,
      freeShippingMessageEnabled = _ref$freeShippingMess === void 0 ? false : _ref$freeShippingMess,
      _ref$mqSingleColumnBe = _ref.mqSingleColumnBelow,
      mqSingleColumnBelow = _ref$mqSingleColumnBe === void 0 ? '' : _ref$mqSingleColumnBe,
      _ref$mqTwoColumnUp = _ref.mqTwoColumnUp,
      mqTwoColumnUp = _ref$mqTwoColumnUp === void 0 ? '' : _ref$mqTwoColumnUp,
      _ref$productDetailsSt = _ref.productDetailsState,
      productDetailsState = _ref$productDetailsSt === void 0 ? {} : _ref$productDetailsSt,
      _ref$scrollToTop = _ref.scrollToTop,
      scrollToTop = _ref$scrollToTop === void 0 ? function () {} : _ref$scrollToTop,
      _ref$setProductImageE = _ref.setProductImageEl,
      setProductImageEl = _ref$setProductImageE === void 0 ? function () {} : _ref$setProductImageE;
  var addons = productDetailsState.addons,
      addonsLoading = productDetailsState.addonsLoading,
      atcQuantity = productDetailsState.atcQuantity,
      atcStatus = productDetailsState.atcStatus,
      dislikeButtonConfig = productDetailsState.dislikeButtonConfig,
      isFreeShipping = productDetailsState.isFreeShipping,
      isMaterial = productDetailsState.isMaterial,
      isPromoExcluded = productDetailsState.isPromoExcluded,
      isReadOnly = productDetailsState.isReadOnly,
      isRestricted = productDetailsState.isRestricted,
      loading = productDetailsState.loading,
      product = productDetailsState.product,
      _productDetailsState$ = productDetailsState.shoppable,
      shoppable = _productDetailsState$ === void 0 ? true : _productDetailsState$,
      swapStatus = productDetailsState.swapStatus,
      uiMessaging = productDetailsState.uiMessaging,
      _productDetailsState$2 = productDetailsState.useVariantsForAll,
      useVariantsForAll = _productDetailsState$2 === void 0 ? false : _productDetailsState$2;

  var _ref2 = product || {},
      _ref2$badge = _ref2.badge,
      badge = _ref2$badge === void 0 ? '' : _ref2$badge,
      _ref2$curatedRec = _ref2.curatedRec,
      curatedRec = _ref2$curatedRec === void 0 ? {} : _ref2$curatedRec,
      _ref2$is2dOnlyProduct = _ref2.is2dOnlyProduct,
      is2dOnlyProduct = _ref2$is2dOnlyProduct === void 0 ? false : _ref2$is2dOnlyProduct,
      _ref2$quantityMultipl = _ref2.quantityMultiple,
      quantityMultiple = _ref2$quantityMultipl === void 0 ? 1 : _ref2$quantityMultipl;

  var hasAddons = addonsLoading || addons.length > 0;
  var isCustomPropUI = badge === 'Exact match' || badge === 'Stand-in';
  var hasCuratedComment = curatedRec === null || curatedRec === void 0 ? void 0 : (_curatedRec$comment = curatedRec.comment) === null || _curatedRec$comment === void 0 ? void 0 : _curatedRec$comment.comment;
  var MATERIAL_PRODUCT_TEXT = 'Not available to purchase through Modsy';

  if (loading) {
    return (
      /*#__PURE__*/
      React.createElement(SkeletonLoader, {
        mqTwoColumnUp: mqTwoColumnUp
      })
    );
  }

  var BottomContent = styles$1.BottomContent,
      FreeShippingMessage = styles$1.FreeShippingMessage,
      Grid = styles$1.Grid,
      LeftContent = styles$1.LeftContent,
      MainContent = styles$1.MainContent,
      MaterialProductMessage = styles$1.MaterialProductMessage,
      StackedImageCarousel = styles$1.StackedImageCarousel;
  var showFreeShipping = isFreeShipping && freeShippingMessageEnabled;
  var showSellableInfo = !isMaterial && !isRestricted && !isReadOnly;
  var showPromoExclusion = isPromoExcluded;
  var VariantsComponent = useVariantsForAll ? VariantsWithAttributes : Variants;
  return (
    /*#__PURE__*/
    React.createElement(Grid, {
      mqTwoColumnUp: mqTwoColumnUp
    },
    /*#__PURE__*/
    React.createElement(LeftContent, {
      mqSingleColumnBelow: mqSingleColumnBelow
    },
    /*#__PURE__*/
    React.createElement(ThumbnailProductImageCarousel, {
      dislikeButtonConfig: dislikeButtonConfig,
      dispatch: dispatch,
      likeDislikeEnabled: shoppable,
      mqTwoColumnUp: mqTwoColumnUp,
      product: product
    })),
    /*#__PURE__*/
    React.createElement(MainContent, null,
    /*#__PURE__*/
    React.createElement(StackedImageCarousel, {
      dislikeButtonConfig: dislikeButtonConfig,
      dispatch: dispatch,
      mqTwoColumnUp: mqTwoColumnUp,
      product: product,
      setProductImageEl: setProductImageEl
    }), isCustomPropUI ?
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(PrimaryInfoCustomProp, {
      product: product
    }),
    /*#__PURE__*/
    React.createElement(SectionBreak, null),
    /*#__PURE__*/
    React.createElement(PhysicalDetailsAndOverview, {
      product: product,
      isCustomPropUI: true
    })) :
    /*#__PURE__*/
    React.createElement(React.Fragment, null, showSellableInfo && hasCuratedComment &&
    /*#__PURE__*/
    React.createElement(CuratedComment, {
      curatedRec: curatedRec,
      mqSingleColumnBelow: mqSingleColumnBelow,
      mqTwoColumnUp: mqTwoColumnUp,
      variant: 'single-column'
    }),
    /*#__PURE__*/
    React.createElement(PrimaryInfo, {
      showPricing: showSellableInfo,
      product: product
    }), showSellableInfo && hasCuratedComment &&
    /*#__PURE__*/
    React.createElement(CuratedComment, {
      curatedRec: curatedRec,
      mqSingleColumnBelow: mqSingleColumnBelow,
      mqTwoColumnUp: mqTwoColumnUp,
      variant: 'two-column'
    }), showFreeShipping &&
    /*#__PURE__*/
    React.createElement(FreeShippingMessage, null, "Free shipping"), showSellableInfo &&
    /*#__PURE__*/
    React.createElement(Availability, {
      product: product,
      wppUiMessaging: uiMessaging
    }), showPromoExclusion &&
    /*#__PURE__*/
    React.createElement(PromoExclusion, null), showSellableInfo &&
    /*#__PURE__*/
    React.createElement(CTA, {
      atcQuantity: atcQuantity,
      atcStatus: atcStatus,
      disabled: !shoppable,
      dispatch: dispatch,
      mqSingleColumnBelow: mqSingleColumnBelow,
      product: product,
      swapStatus: swapStatus,
      quantity: atcQuantity,
      quantityMultiple: quantityMultiple || 1
    }), showSellableInfo &&
    /*#__PURE__*/
    React.createElement(VariantsComponent, {
      dispatch: dispatch,
      productDetailsState: productDetailsState
    }), isMaterial &&
    /*#__PURE__*/
    React.createElement(MaterialProductMessage, null, MATERIAL_PRODUCT_TEXT),
    /*#__PURE__*/
    React.createElement(SectionBreak, null), hasAddons &&
    /*#__PURE__*/
    React.createElement(Addons, {
      addons: addons,
      dispatch: dispatch,
      loading: addonsLoading,
      scrollToTop: scrollToTop
    }), hasAddons &&
    /*#__PURE__*/
    React.createElement(SectionBreak, null), showSellableInfo && is2dOnlyProduct &&
    /*#__PURE__*/
    React.createElement(TwoDOnly, null), showSellableInfo && is2dOnlyProduct &&
    /*#__PURE__*/
    React.createElement(SectionBreak, null),
    /*#__PURE__*/
    React.createElement(PhysicalDetailsAndOverview, {
      isMaterial: isMaterial,
      product: product
    }),
    /*#__PURE__*/
    React.createElement(SectionBreak, {
      mqHide: mqTwoColumnUp
    }))),
    /*#__PURE__*/
    React.createElement(BottomContent, {
      mqSingleColumnBelow: mqSingleColumnBelow
    }, showSellableInfo &&
    /*#__PURE__*/
    React.createElement(AdditionalOptions, {
      dispatch: dispatch,
      mqTwoColumnUp: mqTwoColumnUp,
      productDetailsState: productDetailsState,
      scrollToTop: scrollToTop
    }), showSellableInfo &&
    /*#__PURE__*/
    React.createElement(SimilarProducts, {
      dispatch: dispatch,
      productDetailsState: productDetailsState,
      scrollToTop: scrollToTop
    })))
  );
}

var styles$1 = {
  FreeShippingMessage: styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    ", ";\n    padding: 1rem;\n\n    ", " {\n      padding: 0;\n    }\n  "])), BodyLargeStyles, MQ_FOR_TABLET_LANDSCAPE_UP),
  Grid: styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-areas:\n      \"main-content\"\n      \"bottom-content\";\n\n    ", " {\n      grid-template-columns: 1fr 1fr;\n      grid-template-areas:\n        \"left-content main-content\"\n        \"bottom-content bottom-content\";\n      grid-column-gap: 2rem;\n    }\n  "])), function (p) {
    return p.mqTwoColumnUp;
  }),
  MainContent: styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n    grid-area: main-content;\n\n    display: flex;\n    flex-direction: column;\n  "]))),
  MaterialProductMessage: styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n    ", ";\n    margin: 1rem 0;\n  "])), Header3SmallStyles),
  LeftContent: styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    grid-area: left-content;\n\n    /** hide left column content when we only have space for a single column */\n    ", " {\n      display: none;\n    }\n  "])), function (p) {
    return p.mqSingleColumnBelow;
  }),
  BottomContent: styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    grid-area: bottom-content;\n\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 3rem;\n\n     /** when fixed footer is displayed we need some extra scrolling area */\n     ", " {\n      padding-bottom: 4rem;\n    }\n  "])), function (p) {
    return p.mqSingleColumnBelow;
  }),
  StackedImageCarousel: styled(StackedProductImageCarousel)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    /** Hide the stacked carousel when we have space for two columns */\n    ", " {\n      display: none;\n    }\n  "])), function (p) {
    return p.mqTwoColumnUp;
  })
};

var _templateObject$2, _templateObject2$2;

var MODAL_ID = 'product-details';
var MQ_SINGLE_COLUMN_BELOW = MQ_FOR_TABLET_LANDSCAPE_BELOW;
var MQ_TWO_COLUMN_UP = MQ_FOR_TABLET_LANDSCAPE_UP;
var FADE_OUT_PERIOD_S = 0.45;
/**
 * The modal product details view.
 */

function ProductDetailsModal(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$freeShippingMess = _ref.freeShippingMessageEnabled,
      freeShippingMessageEnabled = _ref$freeShippingMess === void 0 ? false : _ref$freeShippingMess,
      _ref$productDetailsSt = _ref.productDetailsState,
      productDetailsState = _ref$productDetailsSt === void 0 ? {
    addedToCart: null,
    addons: [],
    atcQuantity: 1,
    atcStatus: 'not-in-cart',
    dislikeButtonConfig: 'hover',
    isAltProduct: false,
    isFreeShipping: false,
    isMaterial: false,
    isPromoExcluded: false,
    isSellable: false,
    isRestricted: false,
    loading: false,
    product: {},
    swapStatus: 'unavailable',
    uiMessaging: {},
    variants: {},
    variantsState: {}
  } : _ref$productDetailsSt,
      _ref$tieredPromoEnabl = _ref.tieredPromoEnabled,
      tieredPromoEnabled = _ref$tieredPromoEnabl === void 0 ? false : _ref$tieredPromoEnabl; // We will need to monitor whether or not the product image
  // is currently visible in the document viewport. Storing
  // that ref here and then passing it down to be both set
  // and used in child components as needed.

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      productImageEl = _useState2[0],
      setProductImageEl = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      hideClass = _useState4[0],
      setHideClass = _useState4[1];

  var handleClose = function handleClose() {
    dispatch({
      type: "".concat(MODAL_ID, "-modal-close-request")
    });
  };

  var handleBackNavButtonClick = function handleBackNavButtonClick(jsEvent) {
    dispatch({
      type: 'pd-back-nav-button-click',
      payload: {
        jsEvent: jsEvent
      }
    }); // On internal back navigation, scroll to top of modal.

    scrollModalToTop();
  };

  var addedToCart = productDetailsState.addedToCart,
      product = productDetailsState.product;
  var Modal = styles$2.Modal,
      PreviousProductButton = styles$2.PreviousProductButton;
  var prevAddedToCart = usePrevious(addedToCart);
  useEffect(function () {
    var _addedToCart$product, _prevAddedToCart$prod;

    if (addedToCart && (addedToCart === null || addedToCart === void 0 ? void 0 : (_addedToCart$product = addedToCart.product) === null || _addedToCart$product === void 0 ? void 0 : _addedToCart$product.id) !== (prevAddedToCart === null || prevAddedToCart === void 0 ? void 0 : (_prevAddedToCart$prod = prevAddedToCart.product) === null || _prevAddedToCart$prod === void 0 ? void 0 : _prevAddedToCart$prod.id)) {
      setHideClass('hide');
    } else {
      setHideClass('');
    }

    return function () {
      setHideClass('');
    };
  }, [addedToCart, product]);
  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(Modal, {
      id: MODAL_ID,
      className: "".concat(className, " ").concat(hideClass),
      dispatch: dispatch
    }, productDetailsState.isAltProduct &&
    /*#__PURE__*/
    React.createElement(PreviousProductButton, {
      ariaLabel: "previous product",
      onClick: handleBackNavButtonClick,
      variant: "back"
    }),
    /*#__PURE__*/
    React.createElement(NavOneColumn, {
      dispatch: dispatch,
      mqTwoColumnUp: MQ_TWO_COLUMN_UP,
      onBackNavButtonClick: handleBackNavButtonClick,
      onClose: handleClose,
      productDetailsState: productDetailsState,
      productImageEl: productImageEl
    }),
    /*#__PURE__*/
    React.createElement(ProductDetailsContent, {
      dispatch: dispatch,
      freeShippingMessageEnabled: freeShippingMessageEnabled,
      mqSingleColumnBelow: MQ_SINGLE_COLUMN_BELOW,
      mqTwoColumnUp: MQ_TWO_COLUMN_UP,
      productDetailsState: productDetailsState,
      scrollToTop: scrollModalToTop,
      setProductImageEl: setProductImageEl
    })),
    /*#__PURE__*/
    React.createElement(AddedToCartPopup, {
      dispatch: dispatch,
      productDetailsState: productDetailsState,
      tieredPromoEnabled: tieredPromoEnabled
    }))
  );
}

ProductDetailsModal.propTypes = {
  /** Allows extending modal styles with styled(ProductDetailsModal) constructor. */
  className: PropTypes.string,

  /** For reporting events up to parent */
  dispatch: PropTypes.func,

  /** productDetailsState */
  productDetailsState: PropTypes.shape({
    /**  Added to cart data. */
    addedToCart: PropTypes.object,

    /** Optional addon products data */
    addons: PropTypes.array,

    /** The current add-to-cart quantity value */
    atcQuantity: PropTypes.number,

    /** The current add-to-cart status. One of: */
    atcStatus: PropTypes.oneOf(['not-in-cart', 'adding-to-cart', 'added-to-cart', 'buy-from-retailer']),

    /** The product dislike button configuration */
    dislikeButtonConfig: PropTypes.oneOf(['hover', 'always', 'never']),

    /** Whether or not the product is an unsellable product material (e.g. Paint) */
    isMaterial: PropTypes.bool,

    /** Whether or not product data is currently being fetched */
    loading: PropTypes.bool,

    /** The product data */
    product: PropTypes.object,

    /** The current swap status. One of: */
    swapStatus: PropTypes.oneOf(['available', 'unavailable', 'in-progress', 'in-progress-active']),

    /** Latest Product CTA messaging fields, as of 5/2021 */
    uiMessaging: PropTypes.shape({
      ctaMessaging: PropTypes.string,
      ctaTitle: PropTypes.string,
      isSellable: PropTypes.bool
    }),

    /** Optional variants data */
    variants: PropTypes.object,

    /** Local variants state. */
    variantsState: PropTypes.object
  })
};
/**
 * Helpers
 */

function scrollModalToTop() {
  var modalEl = document.getElementById("".concat(MODAL_ID, "-modal"));

  if (modalEl) {
    modalEl.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
/**
 * Styles
 */


var styles$2 = {
  Modal: styled(FormModal)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n    .", "-modal-container {\n      /** full screen modal for one column layout  */\n      height: 100%;\n      max-height: 100vh;\n      max-width: 100%;\n      margin: 0;\n\n      /** modal with visible overlay for two column layout */\n      ", " {\n        height: 40rem;\n        max-height: calc(100vh - 2rem);\n        max-width: 56.25rem;\n        margin: 1rem 0;\n      }\n    }\n\n    .", "-modal {\n      background-color: ", ";\n      padding: 0;\n\n      ", " {\n        border-radius: 0;\n      }\n\n      ", " {\n        padding: 3rem 2.5rem 0 2.5rem;\n      }\n    }\n\n    .", "-modal-close {\n      /** Hide the 2 column xout when view is single column */\n      ", " {\n        display: none;\n      }\n    }\n\n    transition: ", "s all ease-in-out;\n    opacity: 1;\n    visibility: visible;\n\n    &.hide {\n      opacity: 0;\n      visibility: hidden;\n    }\n  "])), MODAL_ID, MQ_TWO_COLUMN_UP, MODAL_ID, surfaceM, MQ_SINGLE_COLUMN_BELOW, MQ_TWO_COLUMN_UP, MODAL_ID, MQ_SINGLE_COLUMN_BELOW, FADE_OUT_PERIOD_S),
  PreviousProductButton: styled(NavButton)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0.75rem;\n    left: 0.75rem;\n\n    box-shadow: none;\n    border-radius: 0;\n\n    /** Hide the previous product button when view is single column */\n    ", " {\n      display: none;\n    }\n  "])), MQ_SINGLE_COLUMN_BELOW)
};
export default ProductDetailsModal;